import React from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const WarningPopup = ({
  children,
  disabled,
  position = 'top right',
  messageId = 'user.permission.warning',
}) => (
  <Popup
    position={position}
    className="p-0 bg-warn"
    flowing
    disabled={disabled}
    trigger={children}
  >
    <Label className="bg-warn">
      <Icon name="warning sign" />
      <FormattedMessage id={messageId} />
    </Label>
  </Popup>
);

export default WarningPopup;
